<template>
  <hr class="separator " style="margin-top: 1px"/>

  <div>
    <div class="custom-text">
        {{ $t('ProcessAfterSale.processAfterSale') }}
      </div>
    <hr class="separator"/>
  </div>
  <div>
    <!-- TextInfo 组件 -->
    <TextInfo :infoData="infoData" :loading="loading"/>

    <div class="submit-time">{{ $t('ProcessAfterSale.submitTime') }}： {{ submission_time_data }}</div>

    <TableShow :tableData="tableData" :loadData="loadData" :loading="loading" :showOperationColumn="false"/>

    <!-- Pagination 组件 -->
    <PaginationBar :total-records="totalRecords" :current-page="currentPage" :page-size="pageSize"
                   @page-change="handlePageChange" @page-size-change="handlePageSizeChange"/>
    
    <!-- 使用售后处理表单组件，根据状态动态设置只读属性 -->
    <AfterSalesProcessForm :form-data="formData" :readonly="formData.status === 'completed'" />
    
    <div class="form-actions">
      <el-button @click="goBack" class="custom-reset-button"> {{ $t('ProcessAfterSale.return') }}</el-button>
    </div>
  </div>
</template>

<script>
import TextInfo from "./DetailInfoComponents/TextInfo"; // 导入 TextInfo 组件
import PaginationBar from "@/components/PaginationBar";
import {getAfterSalesDetails, showAfterSalesData, updateAfterSalesApply} from "@/api/api";
import TableShow from "@/views/AfterSales/editTask/components/TableShow.vue"; // 导入 Pagination 组件
import AfterSalesProcessForm from "@/components/AfterSalesProcessForm.vue";

export default {
  components: {
    TableShow,
    TextInfo,
    PaginationBar,
    AfterSalesProcessForm
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      totalRecords: 0, // 总记录数
      isEditMode: false, // 编辑模式标识

      contacts: [
        // 初始化联系人信息
        {
          name: "",
          phone: "",
          email: "",
          address: "",
        },
      ],
      infoData: [], // 初始化为一个空对象
      tableData: [], // 初始化为一个空数组
      submission_time_data: '',
      loading: false, // 加载状态
      
      // 表单数据
      formData: {
        productModel: '', // 产品型号
        processingPlan: '', // 跟进处理方案
        isReturnExchange: '', // 是否退换货
        rmaNumber: '', // RMA单号
        isResolved: '', // 是否已解决
        status: '', // 状态
        market: '' // 市场
      }
    };
  },
  async created() {
    const afterSalesId = this.$route.params.taskId;
    this.infoData = []; // 添加这一行
    this.tableData = []; // 添加这一行
    await this.loadData(afterSalesId);
    // 加载售后处理记录（如果存在）
    await this.loadProcessRecord(afterSalesId);
  },
  props: {
    taskId: {
      type: String, // 你的数据类型可能不是字符串
    },
  },
  methods: {
    goBack() {
      // 使用 Vue Router 返回上一个页面
      this.$router.go(-1); // 或者使用 this.$router.back();
    },
    // 处理分页变化事件
    handlePageChange(newPage) {
      this.currentPage = newPage;
    },
    // 处理每页显示条数变化事件
    handlePageSizeChange(newPageSize) {
      this.pageSize = newPageSize;
    },
    async loadData(afterSalesId) {
      this.loading = true; // 开始加载
      try {
        const query = {'after_sale_id-eq': afterSalesId};
        // 调用 fetchData 函数获取数据
        const data = await showAfterSalesData(afterSalesId);
        this.infoData = [
          {customer_name: data.data.customer_name},
          {country: data.data.country_name},
          {address: data.data.address},
          {brand: data.data.brand},
          {phone: data.data.phone},
          {delivery_address: data.data.pick_up_address},
          {email: data.data.email},
          {contact_person: data.data.contact},
          {market: data.data.market},
          {dealer_name: data.data.dealer_name}
        ];

        const page = this.currentPage;
        const pageSize = this.pageSize;
        const responseTableData = await getAfterSalesDetails(page, pageSize, query);

        this.tableData = responseTableData.data.map(item => ({
          after_sales_id: item.after_sale_id,
          motorAppearance: item.appearance_status,
          defectDescription: item.description,
          defectCategory: item.error_type,
          id: item.id,
          defectImages: item.image,
          image_url: item.image_url,
          invoice: item.invoice,
          invoice_url: item.invoice_url,
          materialCode: item.material_code,
          SN: item.sn, // 根据值映射中文名称
          SNLabel: item.sn_label,
          sn_label_url: item.sn_label_url,
          defectVideos: item.video,
          video_url: item.video_url,
        }));
        this.totalRecords = responseTableData.meta.total;
        this.currentPage = responseTableData.meta.current_page; // 更新当前页（如果后端返回当前页信息）
        this.pageSize = parseInt(responseTableData.meta.per_page, 10); // 更新每页记录数
        this.submission_time_data = data.data.commit_at;
        
        // 检查是否有处理记录信息
        if (data.data.solution || data.data.product_model || data.data.status) {
          // 有处理记录，设置为编辑模式
          this.isEditMode = true;
        }
      } catch (error) {
        // 处理错误
        console.error('An error occurred during data loading:', error);
      } finally {
        this.loading = false; // 加载结束
      }
    },
    
    // 加载售后处理记录
    async loadProcessRecord(afterSalesId) {
      try {
        const data = await showAfterSalesData(afterSalesId);
        
        // 如果有处理记录信息，填充到表单中
        if (data.data) {
          this.formData = {
            // 添加id字段，用于提交时识别记录
            id: afterSalesId,
            // 产品型号
            productModel: data.data.product_model || '',
            // 跟进处理方案 - 尝试从solution字段获取
            processingPlan: data.data.solution || '',
            // 是否退换货 - 尝试从is_return字段获取
            isReturnExchange: (data.data.is_return === 1) ? 'true' : 'false',
            // RMA单号 - 尝试从ram_code字段获取
            rmaNumber: data.data.ram_code || '',
            // 是否已解决 - 尝试从is_resolve字段获取
            isResolved: (data.data.is_resolve === 1 ) ? 'true' : 'false',
            // 市场
            market: data.data.market || '',
            // 状态映射 - 将后端数值转换为前端使用的字符串
            status: this.mapStatusValue(data.data.process_status || 0)
          };
        }
      } catch (error) {
        console.error('Failed to load process record:', error);
      }
    },
    
    // 将后端状态数值映射为前端使用的状态字符串
    mapStatusValue(statusValue) {
      const statusMap = {
        0: 'pending',     // 未处理
        1: 'processing',  // 处理中
        2: 'completed'    // 已完成
      };
      return statusMap[statusValue] || 'pending';
    },
    
    // 提交表单
    async submitForm() {
      try {
        // 表单验证
        if (this.formData.isReturnExchange === 'true' && !this.formData.rmaNumber) {
          this.$message.error(this.$t('ProcessAfterSale.rmaNumberRequired'));
          return;
        }
        
        // 准备提交数据
        const submitData = {
          product_model: this.formData.productModel,
          solution: this.formData.processingPlan,
          is_return: this.formData.isReturnExchange === 'true' ? 1 : 0,
          ram_code: this.formData.rmaNumber,
          is_resolve: this.formData.isResolved === 'true' ? 1 : 0,
          market: this.formData.market
        };
        
        // 调用API提交数据（无论编辑还是新增，都使用updateAfterSalesApply）
        const afterSalesId = this.$route.params.taskId;
        await updateAfterSalesApply(afterSalesId, submitData);
        
        this.$message.success(this.$t('ProcessAfterSale.submitSuccess'));
        
        // 可以选择返回上一页或刷新页面
        // this.goBack();
      } catch (error) {
        console.error('Submit form error:', error);
        this.$message.error(this.$t('ProcessAfterSale.submitFailed'));
      }
    },
  },
};
</script>

<style scoped>
.submit-time {
  margin:0 0 40px 20px;
  text-align: left;
  font-size: 14px;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.custom-text {
  text-align: left;
  font-size: 14px;
  margin-bottom: 15px;
  margin-top: 15px;
}

.separator {
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  /* 更透明的横线 */
  margin: 8px 0;
  /* 调整分隔线上下的间距 */
  width: 100%;
  /* 横线占满整个宽度 */
}

/* 表单样式 */
.form-section {
  margin-top: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.form-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  text-align: left;
}

.after-sale-form {
  text-align: left;
}

.after-sale-form .el-form-item {
  margin-bottom: 20px;
}

.after-sale-form .el-input, 
.after-sale-form .el-textarea,
.after-sale-form .el-select {
  width: 400px;
}
</style>
